import { mergeClassName as e } from "../../utils/data.js";
import { ButtonIcon as t } from "../Button/ButtonIcon.js";
import n from "./Calendar.module.js";
import { DayButton as r } from "../../node_modules/react-day-picker/dist/esm/components/DayButton.js";
import { getDefaultClassNames as i } from "../../node_modules/react-day-picker/dist/esm/helpers/getDefaultClassNames.js";
import { DayPicker as a } from "../../node_modules/react-day-picker/dist/esm/DayPicker.js";
import '../../assets/node_modules/@daypicker/react/dist/style.css';/* empty css                                             */
import { createContext as o, useContext as s, useMemo as c } from "react";
import { Fragment as l, jsx as u } from "react/jsx-runtime";
import { CaretLeftIcon as d, CaretRightIcon as f } from "@phosphor-icons/react";
//#region lib/components/DatePicker/DayCalendar.tsx
var p = o(void 0);
function m({ orientation: e, disabled: t }) {
	return /* @__PURE__ */ u(e === "left" ? d : f, {
		size: 24,
		"aria-hidden": !0,
		opacity: t ? .4 : 1
	});
}
function h({ children: e }) {
	let t = s(p);
	return /* @__PURE__ */ u("button", {
		type: "button",
		className: n.captionButton,
		onClick: t,
		children: e
	});
}
function g({ modifiers: t, className: i, ...a }) {
	let o = t.range_start || t.range_middle || t.range_end;
	return /* @__PURE__ */ u(r, {
		...a,
		modifiers: t,
		className: e(i, t.today && !t.selected && n.dayToday, t.selected && !o && n.daySelected)
	});
}
function _({ ...e }) {
	return /* @__PURE__ */ u(t, {
		...e,
		icon: /* @__PURE__ */ u(l, {}),
		shape: "pill",
		color: "neutral",
		style: {
			width: "40px",
			height: "40px"
		}
	});
}
var v = {
	Chevron: m,
	CaptionLabel: h,
	DayButton: g,
	NextMonthButton: _,
	PreviousMonthButton: _
};
function y(t) {
	let { mode: r, selected: o, onSelect: s, numberOfMonths: l = 1, month: d, onMonthChange: f, onCaptionClick: m, className: h, constraints: g } = t, { timeZone: _, noonSafe: y, disabledDates: b, hiddenDates: x, startMonth: S, endMonth: C, today: w, minDays: T, maxDays: E, excludeDisabled: D } = g ?? {}, O = i(), k = {
		animate: !0,
		navLayout: "around",
		numberOfMonths: l,
		month: d,
		onMonthChange: f,
		classNames: c(() => ({
			...O,
			root: e(O.root, n.rdpRoot, h),
			weekday: e(O.weekday, n.weekday),
			day_button: e(O.day_button, n.dayButton)
		}), [h, O]),
		components: v,
		timeZone: _,
		noonSafe: y,
		disabled: b,
		hidden: x,
		startMonth: S,
		endMonth: C,
		today: w
	};
	return r === "single" ? /* @__PURE__ */ u(p.Provider, {
		value: m,
		children: /* @__PURE__ */ u(a, {
			...k,
			mode: "single",
			selected: o,
			onSelect: (e) => {
				s(e);
			}
		})
	}) : /* @__PURE__ */ u(p.Provider, {
		value: m,
		children: /* @__PURE__ */ u(a, {
			...k,
			mode: "range",
			min: T,
			max: E,
			excludeDisabled: D,
			selected: o,
			onSelect: (e) => {
				s(e);
			}
		})
	});
}
//#endregion
export { y as DayCalendar };
